import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import AuthLayout from "./AuthLayout";

const FIELDS = [
  { k: "name", label: "Your name", type: "text", req: true },
  { k: "agency_name", label: "Agency name", type: "text", req: true },
  { k: "email", label: "Work email", type: "email", req: true },
  { k: "phone", label: "Phone", type: "tel" },
  { k: "country", label: "Country", type: "text" },
  { k: "password", label: "Password (min 8 chars)", type: "password", req: true },
];

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", agency_name: "", email: "", phone: "", country: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(form);
      navigate("/app");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Create your agency" subtitle="Browse verified leads and unlock the ones that fit you.">
      <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4" data-testid="register-form">
        {FIELDS.map((f) => (
          <div key={f.k} className={f.k === "email" || f.k === "password" ? "sm:col-span-2" : ""}>
            <Label htmlFor={f.k}>{f.label}</Label>
            <Input id={f.k} type={f.type} required={f.req} minLength={f.k === "password" ? 8 : undefined} className="mt-1.5 h-11"
              data-testid={`register-${f.k.replace("_", "-")}-input`} value={form[f.k]} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })} />
          </div>
        ))}
        {error && <p className="text-sm text-destructive sm:col-span-2" data-testid="register-error">{error}</p>}
        <Button type="submit" className="w-full h-11 sm:col-span-2" disabled={busy} data-testid="register-submit-button">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Create account</Button>
        <p className="text-sm text-center text-muted-foreground sm:col-span-2">Already registered? <Link to="/login" className="text-primary font-medium hover:underline" data-testid="login-link">Sign in</Link></p>
      </form>
    </AuthLayout>
  );
}
